import React, { useEffect, useState } from "react";
import "./Privacy_policy.css";
import { fetchCmsDataApi } from "../../../../services/faqs";
import { toastMessage } from "../../../../utils/toastMessage";
import CmsShimmer from "../../../../shimmer/CMS/CmsShimmer";
import useShimmer from "../../../../hooks/useShimmer";

const Privacy = () => {
  const [privacyData, setPrivacyData] = useState("");
  const [showShimmer, setShowShimmer] = useShimmer(CmsShimmer);

  const getPrivacyHandler = async () => {
    try {
      setShowShimmer(true);
      const { data } = await fetchCmsDataApi({ type: "PRIVACY" });
      const { data: privacy, success, message } = data;
      if (success) {
        // toastMessage(message, "success", "privacy");
        setPrivacyData(privacy);
      } else {
        toastMessage(message, "error", "privacy");
      }
    } catch (e) {
      console.log("Login:-", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  useEffect(() => {
    getPrivacyHandler();
  }, []);

  return (
    <>
      <div className="Privacy_policy">
        <div className="container_privacy_policy">
          <h3 className="profile_title">Privacy Policy</h3>
          {/* <div className="privacy_policy_heading">
            <h3>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.{" "}
            </h3>
  </div> */}
          {showShimmer || (
            <p
              dangerouslySetInnerHTML={{
                __html: privacyData?.description,
              }}
            ></p>
          )}
        </div>
      </div>
    </>
  );
};

export default Privacy;
